import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import EMPButton from "../../shared/components/EMPButton/EMPButton";

const StripeOnboardingErrorState = ({ t, onRetry }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "310px",
      textAlign: "center",
      p: 4,
    }}
  >
    <Typography variant="h6" color="error.dark" gutterBottom>
      {t("NVCOnboarding.stripe.error.title")}
    </Typography>
    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
      {t("NVCOnboarding.stripe.error.description")}
    </Typography>
    <EMPButton
      variant="contained"
      onClick={onRetry}
      testId="retry-stripe-button"
    >
      {t("common.buttonCtas.tryAgain")}
    </EMPButton>
  </Box>
);

StripeOnboardingErrorState.propTypes = {
  t: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default StripeOnboardingErrorState;
